export default __webpack_public_path__ + "static/invest-public-health-healthcare-accomplishment-3b-c788f146e9552a2d3817814a21d30c1b.webp";